module.exports = __webpack_public_path__ + "static/part-9-ed8ae98c5d885b4d1928a681eefbe7c4.svg";